module.exports = __webpack_public_path__ + "img/trainroom1.e4e06c59.png";